import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import LatestUpdates from './components/LatestUpdates';
import StatsBar, { CTABanner } from './components/StatsBar';

export default function Home() {
  useEffect(() => {
    document.title = '福利视频网站 - 免费高清视频资源一站式汇聚平台';
  }, []);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroBanner />
          <CategoryNav />
          <StatsBar />
          <FeaturedVideos />
          <LatestUpdates />
          <CTABanner />
        </main>

        <Footer />
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '福利视频网站',
            url: 'https://fulishipin.com',
            description:
              '福利视频网站为您汇聚海量免费高清视频资源，覆盖影视、综艺、短片等多种类型内容，无需注册即可畅享优质视频福利。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://fulishipin.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '福利视频网站',
            url: 'https://fulishipin.com',
            logo: 'https://fulishipin.com/logo.png',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-9999',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              streetAddress: '光华路88号',
              addressCountry: 'CN',
            },
          }),
        }}
      />
    </>
  );
}